const app = {
  namespaced: true,
  state: {
    wxConfigObj: {
      a: 1
    }
  },
  getters: {},
  mutations: {},
  actions: {
    async queryWxConfigParams({ rootState }, params = {}) {
      const data = await rootState.http("/customer/getCustomer", params);
      return data;
    },
    async weixinLogin({ rootState }, params = {}) {
      const data = await rootState.http("/userAccount/third/weixinOfficialAccount/login", params);
      return data;
    },
    // 查询裂变活动短链接详细信息
    async queryFnCodeContent({ rootState }, params = {}) {
      const data = await rootState.http("/memberCampaign/fission/queryFissionShareCodeContent", params);
      return data;
    },
    async createFissionOrder({ rootState }, params = {}) {
      const data = await rootState.http("/memberCampaign/fission/buyFission", params);
      return data;
    },
    async queryFissionOrder({ rootState }, params = {}) {
      const data = await rootState.http("/memberCampaign/fission/queryParticipateFissionCampaignPage", params);
      return data;
    },
    async queryFissionShareUrl({ rootState }, params = {}) {
      const data = await rootState.http("/memberCampaign/fission/createShareImage", params);
      return data;
    },
    async queryFissionBuyRecord({ rootState }, params = {}) {
      const data = await rootState.http("/memberCampaign/queryPurchaseHistoryPage", params);
      return data;
    },
    async queryFissionSource({ rootState }, params = {}) {
      const data = await rootState.http("/memberCampaign/getFissionFrontPageText", params);
      return data;
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/fission.js